var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolChatbotLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26747_22311)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26747_22311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3969 14.9206C29.3969 6.96927 22.9511 0.523438 14.9997 0.523438C7.04837 0.523438 0.602539 6.96927 0.602539 14.9206C0.602539 22.872 7.04837 29.3178 14.9997 29.3178C22.9511 29.3178 29.3969 22.872 29.3969 14.9206Z",
    fill: "url(#paint0_linear_26747_22311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 14.9165C29.5 6.90838 23.0081 0.416504 15 0.416504C6.99187 0.416504 0.5 6.90838 0.5 14.9165C0.5 22.9246 6.99187 29.4165 15 29.4165C23.0081 29.4165 29.5 22.9246 29.5 14.9165Z",
    fill: "url(#paint1_linear_26747_22311)",
    stroke: "url(#paint2_linear_26747_22311)",
    strokeWidth: 0.201719
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26747_22311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3974 14.9172C29.3974 6.96585 22.9515 0.52002 15.0002 0.52002C7.04886 0.52002 0.603027 6.96585 0.603027 14.9172C0.603027 22.8685 7.04886 29.3144 15.0002 29.3144C22.9515 29.3144 29.3974 22.8685 29.3974 14.9172Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26747_22311)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_26747_22311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6363 9.91553C21.6954 9.91553 14.4645 29.5202 0.679932 16.6547L2.82419 33.5024L46.0157 34.7277V14.204C37.1323 21.2495 33.5773 9.91558 27.6363 9.91553Z",
    fill: "url(#paint3_linear_26747_22311)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_26747_22311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.89863 10.0146C10.8396 10.0146 18.0705 29.6193 31.8551 16.7538L29.7108 33.6015L-13.4807 34.8268V14.3032C-4.59737 21.3486 -1.04235 10.0147 4.89863 10.0146Z",
    fill: "url(#paint4_linear_26747_22311)",
    fillOpacity: 0.7
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26747_22311",
    x: 0.39917,
    y: 0.31543,
    width: 29.2017,
    height: 30.009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.01719
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.439216 0 0 0 0 0.929412 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26747_22311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.806874
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37169
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26747_22311",
    result: "effect2_innerShadow_26747_22311"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_26747_22311",
    x: -2.54756,
    y: 7.09147,
    width: 51.7907,
    height: 31.267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.403437
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.61375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26747_22311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26747_22311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_26747_22311",
    x: -16.7082,
    y: 4.2455,
    width: 54.3323,
    height: 34.2121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.403437
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.61375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26747_22311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26747_22311",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 14.5238,
    dy: -6.85846
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.88458
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_26747_22311"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26747_22311",
    x1: 6.77278,
    y1: 24.9986,
    x2: 27.7291,
    y2: 10.5103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678371,
    stopColor: "#4862F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8A7DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26747_22311",
    x1: 6.71431,
    y1: 25.0665,
    x2: 27.8203,
    y2: 10.4747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678371,
    stopColor: "#4862F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8A7DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26747_22311",
    x1: 29.3543,
    y1: 0.519341,
    x2: 0.645751,
    y2: 29.3137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3AEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26747_22311",
    x1: 23.3478,
    y1: 9.91553,
    x2: 23.3478,
    y2: 34.7277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7DE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26747_22311",
    x1: 9.18718,
    y1: 10.0146,
    x2: 9.18718,
    y2: 34.8268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7DE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26747_22311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolChatbotLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_chatbot_logo.38708e106527318766f2932ff74670da.svg";